import React, { Fragment, useCallback } from 'react';
import { XCircleIcon } from '@heroicons/react/24/solid';
import { ShareIcon } from '@heroicons/react/24/outline';
import { Dialog, Transition } from '@headlessui/react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.css";

import { GUIDE_ANALYTIC_LINK } from '../../constants';
import Analytic0 from "../../images/Analytic_Guide/Analytics0.png"
import Analytic1 from "../../images/Analytic_Guide/Analytics1.png"
import Analytic2 from "../../images/Analytic_Guide/Analytics2.png"
import Analytic3 from "../../images/Analytic_Guide/Analytics3.png"
import Analytic4 from "../../images/Analytic_Guide/Analytics4.png"
import Analytic5 from "../../images/Analytic_Guide/Analytics5.png"
import Analytic6 from "../../images/Analytic_Guide/Analytics6.png"

export function CarouselAnalytic({ open, setOpen }) {

  const handleCloseDialog = useCallback(() => {
    setOpen(false);
  }, [])

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={handleCloseDialog}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500/75 backdrop-filter backdrop-blur-sm transition-opacity" />
        </Transition.Child>

        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative rounded-3xl px-6 transform transition-all sm:my-8 lg:max-w-6xl 3xl:max-w-7xl sm:max-w-sm sm:p-12">
                <button className="absolute -right-10 3xl:-right-32 top-10 z-50" onClick={handleCloseDialog}><XCircleIcon className="h-7 w-7 text-gray-500 hover:text-gray-600 transition-colors" /></button>
                <Carousel
                  emulateTouch
                  useKeyboardArrows
                  swipeable
                  showArrows
                  showIndicators
                  showThumbs={false}
                >
                  <img src={Analytic0} alt="Analytic0" />
                  <img src={Analytic1} alt="Analytic1" />
                  <img src={Analytic2} alt="Analytic2" />
                  <img src={Analytic3} alt="Analytic3" />
                  <img src={Analytic4} alt="Analytic4" />
                  <img src={Analytic5} alt="Analytic5" />
                  <img src={Analytic6} alt="Analytic6" />
                </Carousel>
                <a
                  href={GUIDE_ANALYTIC_LINK}
                  target='_blank'
                  className='transition-shadow rounded-full group inline-flex space-x-2 text-white bg-general-teal items-center py-3 px-6 hover:shadow-lg mt-4 font-medium text-sm leading-5 disabled:text-gray-500 disabled:bg-gray-200 disabled:cursor-not-allowed'
                >
                  <ShareIcon className='w-5 h-5' />
                  <span>Partager en PDF.</span>
                </a>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}